import { render, staticRenderFns } from "./RequisitionItemMedia.vue?vue&type=template&id=12becd0d&scoped=true&"
import script from "./RequisitionItemMedia.vue?vue&type=script&lang=ts&"
export * from "./RequisitionItemMedia.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionItemMedia.vue?vue&type=style&index=0&id=12becd0d&lang=scss&scoped=true&"
import style1 from "./RequisitionItemMedia.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12becd0d",
  null
  
)

export default component.exports